<template>
  <wrap ref="wrap" class="dialog" :title="title">
    <div class="date clearBoth">
    </div>
    <div class="wrap">
      <p v-if="step > 1" style="line-height: 40px;text-align: right;">
        <a href="javascript:;" @click="onBack">返回</a>
      </p>
      <ul ref="list" class="table-list">
        <li class="qc-16" v-if="step === 1">
          <template>
            <p>{{ body.prev.title }}</p>
            <CTable class="table-w" :head="head" :body="body.prev.list">
              <template slot-scope="{data}" slot="result">
                <span
                  :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}"
                >{{ data.result }}</span>
              </template>
              <template slot-scope="{data}" slot="action">
                <a
                  href="javascript:;"
                  v-if="data.weekday"
                  class="tc-b_h review"
                  @click="toTwo(data)"
                >查看</a>
              </template>
            </CTable>
          </template>

          <template>
            <p>{{ body.current.title }}</p>
            <CTable class="table-w" :head="head" :body="body.current.list">
              <!--
                自定义模版-本周
                slot=head字段名
                slot-scope=数据索引
              -->
              <template slot-scope="{data}" slot="action">
                <a
                  href="javascript:;"
                  v-if="data.weekday"
                  class="tc-b_h review"
                  @click="toTwo(data)"
                >查看</a>
              </template>

              <template slot-scope="{data}" slot="result">
                <span
                  :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}"
                >{{ data.result }}</span>
              </template>

              <template slot-scope="{data}" slot="xdje">
                <span class="red">{{ data.xdje }}</span>
              </template>

              <template slot-scope="{data}" slot="res">
                <span class="red">{{ data.res }}</span>
              </template>
            </CTable>
          </template>
        </li>

        <li class="qc-16" v-if="step===2">
          <CTable class="table-w" :head="head" :body="two_list">
            <template slot-scope="{data}" slot="result">
              <span
                :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}"
              >{{ data.result }}</span>
            </template>
            <template slot-scope="{data}" slot="lottery_name_link">
              <a @click="toThree(data)" href="javascript:;">{{ data.lottery_name }}</a>
            </template>
          </CTable>
        </li>

        <li class="qc-16" v-if="step===3">
          <CTable class="table-w" :head="head" :body="three_list">
            <template slot-scope="{data}" slot="result">
              <span
                :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}"
              >{{ data.result }}</span>
            </template>
            <template slot="period" slot-scope="{data}">
              <a href="javascript:;" @click="toFour(data)">{{ data.period }}</a>
            </template>
          </CTable>
        </li>
        <li class="qc-16" v-if="step===4">
          <ul slot="recodeNumber" class="lh_num_record" v-if="lottery_type==19">
            开奖结果：
            <li v-for="(item, index) in getNumberData()" :key="'re' + index" class="item lh_item ft_item">
              <span class="numberlhc" :class="filterNumberColor1(item, index)">{{ item }}</span>
            </li>
          </ul>
          <ul slot="recodeNumber" class="lh_num_record" v-else>
            开奖结果：
            <li v-for="(item, index) in getNumberData()" :key="'re' + index" class="item lh_item">
              <span class="numberlhc" :class="filterNumberColor(item, index)">{{ item }}</span>
            </li>
          </ul>
          <CTable class="table-w" :head="head" :body="four_list">
            <template slot-scope="{data}" slot="win">
              <span :style="{'color':data.win<0?'green' : data.win > 0 ? 'red' : ''}">{{ data.win }}</span>
            </template>
            <template slot="class2_class3" slot-scope="{data}">
              <span>{{ data.class2 }}</span>
              <Popover placement="right" trigger="click" v-if="data.class4!=null">
                <Table border :data="data.class4" style="max-height:400px;overflow:auto">
                  <TableColumn width="150" property="class3" label="号码">
                    <template slot-scope="scope">
                      <span :class="[scope.row.is_win==1 ? 'red' : '']">{{ scope.row.class3 }}</span>
                    </template>
                  </TableColumn>
                  <TableColumn width="80" property="odds" label="中二赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                    <template slot-scope="scope">
                      <span
                        :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{
                          scope.row.odds
                        }}</span>
                    </template>
                  </TableColumn>
                  <TableColumn width="80" property="odds" label="中特赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                    <template slot-scope="scope">
                      <span
                        :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{
                          scope.row.odds
                        }}</span>
                    </template>
                  </TableColumn>
                  <TableColumn width="80" property="odds" label="赔率" v-else>
                    <template slot-scope="scope">
                      <span :class="[scope.row.is_win==1 ? 'red' : '']">{{ scope.row.odds }}</span>
                    </template>
                  </TableColumn>
                  <TableColumn width="80" property="odds" label="中三赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                    <template slot-scope="scope">
                      <span
                        :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{
                          scope.row.odds2
                        }}</span>
                    </template>
                  </TableColumn>
                  <TableColumn width="80" property="odds" label="中二赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                    <template slot-scope="scope">
                      <span
                        :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{
                          scope.row.odds2
                        }}</span>
                    </template>
                  </TableColumn>
                </Table>
                <p style="text-align: right;margin-top: 5px;">共 <span class="red">{{ data.zs }}</span> 注，每注 <span
                  class="red">{{ data.money2 }}</span> 元<span v-if="data.status!=1">，中 <span
                  class="red">{{ data.win_zs }}</span> 注</span></p>
                <span slot="reference"><span class="hasClass4">{{ data.class3 }}</span></span>
              </Popover>
              <span class="blue" v-else>{{ data.class3 }}</span>
            </template>
            <template slot-scope="{data}" slot="odds_odds2">
              <span v-if="data.class2=='三中二'||data.class2=='二中特' || data.class2=='三中二X'||data.class2=='二中特X'">{{ data.odds }}/{{ data.odds2 }}</span>
              <span v-else>{{ data.odds }}</span>
            </template>
            <template slot-scope="{data}" slot="status">
              <span class="green" v-if="data.status==1 || data.status==2">有效</span>
              <span class="red" v-else-if="data.status==3">取消
                <p v-if="data.cancel_time!=''">{{data.cancel_time}}</p>
              </span>
            </template>
          </CTable>
        </li>
      </ul>
    </div>
  </wrap>
</template>

<script>
import { history, history2, history3, history4 } from "../../service/report";
import myDatepicker from "vue-datepicker-local";
import objectPath from 'object-path';
import QC35 from "./QC35";
import QC36 from "./QC36";
import CTable from "./table";
import Wrap from "./wrap";
import CSelect from "../c_select";
import { mapState } from "vuex";
import { Popover, Table, TableColumn, } from "element-ui";
import { filterNumber } from "../../utils/objectFactory";

export default {
  name: "QC15",
  components: {Wrap, CTable, myDatepicker, QC35, QC36, CSelect, Popover, Table, TableColumn},
  watch: {
    type() {
      if (this.step == 1) {
        this.loadInfo();
      } else if (this.step == 2) {
        this.toTwo({date: this.date});
      }
    }
  },
  computed: {
    ...mapState({
      options: state =>
        state.home.headTabs.map((item, index) => ({
          label: item.title,
          value: item.lottery_type,
          category: item.category
        }))
    }),
    head() {
      if (this.step === 1) {
        return [
          {label: "交易日期", value: "date"},
          {label: "星期", value: "weekday"},
          {label: "下注金额", value: "bet_money"},
          {label: "有效金额", value: "bet_money_real"},
          {label: "注数", value: "count"},
          {label: "退水", value: "commission"},
          {label: "输赢", value: "result"},
          {label: "操作", value: "action"}
        ];
      }
      if (this.step === 2) {
        return [
          {label: "彩票类型", value: "lottery_name_link"},
          {label: "注数", value: "count"},
          {label: "下注金额", value: "bet_money"},
          {label: "有效金额", value: "bet_money_real"},
          {label: "退水", value: "commission"},
          {label: "输赢", value: "result"}
        ];
      }
      if (this.step === 3) {
        return [
          {label: "期号", value: "period"},
          {label: "彩票类型", value: "lottery_name"},
          {label: "注数", value: "count"},
          {label: "下注金额", value: "bet_money"},
          {label: "有效金额", value: "bet_money_real"},
          {label: "退水", value: "commission"},
          {label: "输赢", value: "result"}
          // 详情
        ];
      }
      if (this.step === 4) {
        return [
          {label: "订单号", value: "order_id"},
          {label: "时间", value: "date_time"},
          {label: "期号", value: "period"},
          {label: "类型", value: "class2_class3"},
          {label: "赔率", value: "odds_odds2"},
          {label: "投注金额", value: "money"},
          {label: "退水", value: "rebate"},
          {label: "输赢", value: "win"},
          {label: '状态', value: 'status'}
        ];
      }
    }
  },
  data() {
    return {
      step: 1,
      type: 0,
      // 彩种
      lottery_type: "",
      // 日期
      date: "",

      date_end: "",
      date_start: "",
      body: {
        current: {
          title: "本周下注状况",
          list: []
        },
        prev: {
          title: "上周下注状况",
          list: []
        }
      },
      two_list: [],
      three_list: [],
      four_list: [],
      title: '结算报表',
      four_draw: {
        draw_results: [],
        sum: {} //
      } // 开奖信息
    };
  },
  methods: {
    getNumberData() {
      const {draw_results} = this.four_draw;
      return draw_results;
    },
    // 过滤当前number的背景图片颜色
    filterNumberColor(checkNumber, index) {
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      return '';
    },
    filterNumberColor1(checkNumber,index) {
        if(index==0){
          return 'ball_yellow';
        }else{
          return 'number-'+checkNumber;
        }
    },
    onBack() {
      this.step--;
      this.title = `结算报表`;
    },
    async toFour(item) {
      this.title = `结算报表-${item.period || 0}期`;
      this.step++;
      this.loading = true;
      const info = await history4({
        period: item.period,
        lottery_type: this.lottery_type
      });
      this.loading = false;
      if (info.result === "ok") {
        this.four_list = info.data.data || [];
        this.four_draw = info.data.draw || {};
      }
    },

    async toThree(item) {
      this.step++;
      this.lottery_type = item.lottery_type;
      this.loading = true;
      const info = await history3({
        date: this.date,
        lottery_type: this.lottery_type
      });
      this.loading = false;
      if (info.result === "ok") {
        this.three_list = (info.data || []).map(e => {
          e.lottery_name = item.lottery_name;
          return e;
        });
      }
    },
    sum(list, key) {
      const f = n => Math.round(n * 10000) / 10000;
      return list.reduce((p, n) => f(p + n[key]), 0);
    },
    async toTwo({date}) {
      if (this.type == "all") var lottery_id = "";
      else var lottery_id = this.type;
      this.step = 2;
      this.date = date;
      this.loading = true;
      const info = await history2(date, lottery_id);
      this.loading = false;
      if (info.result === "ok") {
        this.two_list = info.data;
      }
    },
    async loadInfo() {
      if (this.type == "all") var lottery_id = "";
      else var lottery_id = this.type;
      this.loading = true;
      const info = await history(lottery_id);
      this.loading = false;
      if (info.result !== "ok") return this.$Message.error(info.msg);
      this.body.current.list = info.data.current_week || [];
      this.body.current.list.push({
        date: "本周合计",
        bet_money: this.sum(this.body.current.list, "bet_money"),
        bet_money_real: this.sum(this.body.current.list, "bet_money_real"),
        count: this.sum(this.body.current.list, "count"),
        result: this.sum(this.body.current.list, "result"),
        commission: this.sum(this.body.current.list, "commission")
      });

      this.body.prev.list = info.data.last_week || [];

      this.body.prev.list.push({
        date: "上周合计",
        bet_money: this.sum(this.body.prev.list, "bet_money"),
        bet_money_real: this.sum(this.body.prev.list, "bet_money_real"),
        count: this.sum(this.body.prev.list, "count"),
        result: this.sum(this.body.prev.list, "result"),
        commission: this.sum(this.body.prev.list, "commission")
      });

      const list = [
        this.body.current.list[this.body.current.list.length - 1],
        this.body.prev.list[this.body.prev.list.length - 1]
      ];

      this.body.current.list.push({
        date: "两周总计",
        bet_money: this.sum(list, "bet_money"),
        bet_money_real: this.sum(list, "bet_money_real"),
        count: this.sum(list, "count"),
        result: this.sum(list, "result"),
        commission: this.sum(list, "commission")
      });
    },
    show() {
      this.$refs.wrap.show();
    },
    hide() {
      this.$refs.wrap.hide();
    },

    /**
     * 合计
     * @param arr
     * @returns {string}
     */
    reduceArr(arr) {
      const plus = arr.reduce((prev, cur) => {
        return parseFloat(prev) + parseFloat(cur);
      }, 0);
      return plus.toString() === "NaN" ? "—" : plus;
    },
    calOffsetLeft() {
      this.list = this.$refs.list;
      const children = this.list.children;
      return Array.from(children, dom => dom.offsetLeft);
    }
  },
  mounted() {
    this.options.unshift({
      label: "全部",
      value: "all"
    });

    this.type = this.options[0].value;
  }
};
</script>
<style>
.el-table td, .el-table th {
  padding: unset !important;
}

.el-table .cell {
  line-height: unset !important;
}

.el-table .cell span {
  line-height: 10px;
  font-size: 10px;
}

.hasClass4 {
  border-bottom: 1px dashed #1e90ff;
  color: #1e90ff;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
}
</style>
<style lang="stylus" scoped>
/* .tc-b_h {
  &.review {
    color: #000000;
  }
} */
.dialog {
  .select {
    width: auto;
    min-width: 140px;
    height: 27px;
    border-radius: 2px;
    margin-right: 10px;
    background-color: transparent;
    border: 1px solid #e0e0e0;
    float: left;
  }

  overflow-x: hidden;
}

.wrap {
  width: 100%;
  height: 100%;
}

.certain, .back {
  width: 85px;
  height: 35px;
}

.certain {
  margin-top: 10px;
}

.table-w + .table-w {
  margin-top: 10px;
}

.table-list {
  position: relative;
  white-space: nowrap;

  li {
    width: 100%;
    display: inline-block;
    margin-right: 0;
    vertical-align: top;
  }
}

.qc .table-w {
  margin-top: 10px;
}

.qc-16 {
  p {
    margin: 3px 0;
    line-height: 30px;
    font-size: 14px;
  }
}

.lh_num_record {
  display: flex;
  align-items: center;
  position: absolute;
  top: -35px;
  left: 10px;
  width: 50%;

  .lh_item {
    display: flex;
    align-items: center;
    margin-left: 0;
    margin-right: 2px;
  }

  .ft_item{
    width:50px
  }

  .numberlhc {
    width: 25px;
    height: 25px;
    display: flex;
    line-height: 25px;
    align-items: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
  }

  .number-blue {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_blue.png') no-repeat center center;
    padding-bottom: 2px;
  }

  .number-green {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_green.png') no-repeat center center;
    padding-bottom: 2px;
  }

  .number-red {
    color:#0b0c0c;
    font-weight: bold;
    background: url('../../assets/back_red.png') no-repeat center center;
    padding-bottom: 2px;
  }

  .ball_yellow{
    color:#363636;
    background: url('../../assets/ball_yellow.png') no-repeat center center;
  }
  .number-1 {
    color:#363636;
    background: url('../../assets/1.fw.png') no-repeat center center;
  }

  .number-2 {
    color:#363636;
    background: url('../../assets/2.fw.png') no-repeat center center;
  }

  .number-3 {
    color:#363636;
    background: url('../../assets/3.fw.png') no-repeat center center;
  }

  .number-4 {
    color:#363636;
    background: url('../../assets/4.fw.png') no-repeat center center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/QC16.vue